var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4203 10.825C12.305 10.825 13.8328 9.29716 13.8328 7.41249C13.8328 5.52783 12.305 4 10.4203 4C8.53564 4 7.00781 5.52783 7.00781 7.41249C7.00781 9.29716 8.53564 10.825 10.4203 10.825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6032 11.4971C9.60616 11.4568 8.61133 11.6187 7.67852 11.9729C6.74571 12.3271 5.8942 12.8664 5.17523 13.5583L4.98438 13.7721V18.6045C4.98735 18.7619 5.02131 18.9172 5.08432 19.0615C5.14732 19.2058 5.23813 19.3362 5.35156 19.4454C5.46499 19.5546 5.59882 19.6403 5.7454 19.6978C5.89198 19.7552 6.04844 19.7832 6.20585 19.7802H14.9776C15.135 19.7832 15.2914 19.7552 15.438 19.6978C15.5846 19.6403 15.7184 19.5546 15.8319 19.4454C15.9453 19.3362 16.0361 19.2058 16.0991 19.0615C16.1621 18.9172 16.1961 18.7619 16.199 18.6045V13.7873L16.0158 13.5583C15.3015 12.8643 14.453 12.3235 13.5222 11.9691C12.5915 11.6146 11.5982 11.454 10.6032 11.4971Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.582,
    y: 7.43555,
    width: 1.14513,
    height: 5.72566,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.293,
    y: 10.8711,
    width: 1.14513,
    height: 5.72566,
    transform: "rotate(-90 15.293 10.8711)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/userManagement.d5409ecf87581e51381f9019cdfbbbd3.svg";
export { ForwardRef as ReactComponent };